<template>
    <div>
        <MainBanner />
        <DespreNoi :content="trainingContentOne" />
        <FilozofiaNoastra />
        <ServiciileNoastre />
        <MetodaAtelierului />
        <ClientiiNostri />
        <EchipaNoastra />
        <Contact />
    </div>
</template>

<script>
import MainBanner from '../components/ASMainBanner'
import DespreNoi from '../components/ASDespreNoi'
import FilozofiaNoastra from '../components/ASFilozofiaNoastra'
import ServiciileNoastre from '../components/ASServiciileNoastre'
import MetodaAtelierului from '../components/ASMetodaAtelierului'
import ClientiiNostri from '../components/ASClientiiNostri'
import EchipaNoastra from '../components/ASEchipaNoastra'
import Contact from '../components/ASContact'

export default {
    name: 'HomePage',
    components: {
        MainBanner,
        DespreNoi,
        FilozofiaNoastra,
        ServiciileNoastre,
        MetodaAtelierului,
        ClientiiNostri,
        EchipaNoastra,
        Contact,
    },
    data() {
        return {
            trainingContentOne: {
                title: 'Mai Mult Decât o Firmă de Software',
                description: '<p>Nu suntem o corporație fără chip. Suntem un colectiv de specialiști software — fiecare cu propria firmă și cu ani de experiență în tranșeele tehnologiei. După nenumărate proiecte în care am colaborat pentru a livra soluții complete, am realizat un lucru simplu: împreună suntem mai puternici. Atelierul de Software s-a născut din această sinergie, din dorința de a oferi clienților noștri un singur partener de încredere, capabil să rezolve provocări complexe, de la ERP la aplicații web integrate.</p><p>Dincolo de cod, parteneriatul cu noi se bazează pe trei promisiuni clare:</p>',
                features: [
                    { icon: 'bx bxs-cloud', title: 'Expertiză Completă, Un Singur Contact:', text: 'Ai acces la specialiști în ERP, CRM, WMS și Web sub un singur acoperiș. Gata cu jongleriile între mai mulți furnizori.' },
                    { icon: 'bx bx-network-chart', title: 'Flexibilitate și Viteză:', text: 'Fiind o structură agilă, comunicarea este directă, iar deciziile se iau rapid. Adaptăm soluțiile pe parcurs, fără birocrația marilor companii.' },
                    { icon: 'bx bxs-server', title: 'Soluții pe Termen Lung:', text: 'Nu construim doar pentru prezent. Gândim arhitecturi scalabile care cresc odată cu afacerea ta, integrând viitorul în fiecare proiect.' },
                    // { icon: 'bx bx-bar-chart-alt-2', title: 'Beginner Analytics', text: 'Learn the fundamentals of data analysis and visualization.' },
                    // { icon: 'bx bx-brain', title: 'Machine Learning Basics', text: 'An introduction to predictive modeling and algorithms.' },
                    // { icon: 'bx bx-data', title: 'SQL for Data Science', text: 'Master the art of querying databases to extract insights.' },
                ]
            },
            trainingContentTwo: {
                title: 'Ce înseamnă parteneriatul cu Atelierul de Software pentru tine?',
                description: 'Dincolo de cod, parteneriatul cu noi se bazează pe trei promisiuni clare:',
                features: [
                    { icon: 'bx bx-bar-chart-alt-2', title: 'Beginner Analytics', text: '[Aici introduceți Punctul 1 - ex: Expertiză Completă, Un Singur Contact]' },
                    { icon: 'bx bx-map', title: 'Machine Learning Basics', text: '[Aici introduceți Punctul 2 - ex: Flexibilitate și Viteză]' },
                    { icon: 'bx bxs-cloud', title: 'Expertiză Completă, Un Singur Contact:', text: 'Ai acces la specialiști în ERP, CRM, WMS și Web sub un singur acoperiș. Gata cu jongleriile între mai mulți furnizori.' },
                    { icon: 'bx bx-network-chart', title: 'Flexibilitate și Viteză:', text: 'Fiind o structură agilă, comunicarea este directă, iar deciziile se iau rapid. Adaptăm soluțiile pe parcurs, fără birocrația marilor companii.' },
                    { icon: 'bx bxs-server', title: 'Soluții pe Termen Lung:', text: 'Nu construim doar pentru prezent. Gândim arhitecturi scalabile care cresc odată cu afacerea ta, integrând viitorul în fiecare proiect.' },
                ]
            }
        }
    }
}
</script>

